import { createReducer } from '@reduxjs/toolkit';
import { AppShape } from './model';
import * as appActions from './actions';
import * as lastStateActions from '../lastState/actions';

const initial: AppShape = {
  initialized: false,
  user: null,
  sidebarExpanded: true,
  sidebarWidth: 200,
  sidebarDragging: false,
  settings: undefined,
  slowNetwork: false,
};

export const appReducer = createReducer<AppShape>(initial, (builder) =>
  builder
    .addCase(appActions.initialized, (s) => {
      s.initialized = true;
    })
    .addCase(appActions.userLoaded, (s, a) => {
      s.user = a.payload.user;
    })
    .addCase(appActions.sidebarExpandedChanged, (s, a) => {
      s.sidebarExpanded = a.payload.sidebarExpanded;
    })
    .addCase(appActions.sidebarWidthChanged, (s, a) => {
      s.sidebarWidth = a.payload.sidebarWidth;
    })
    .addCase(appActions.setSidebarDragging, (s, a) => {
      s.sidebarDragging = a.payload.sidebarDragging;
    })
    .addCase(lastStateActions.applied, (s, a) => {
      s.sidebarExpanded = a.payload?.state.data.app?.sidebarExpanded ?? s.sidebarExpanded;
    })
    .addCase(appActions.settingsLoaded, (s, a) => {
      s.settings = a.payload.settings;
    })
    .addCase(appActions.slowNetworkChanged, (s, a) => {
      s.slowNetwork = a.payload.slow;
    }),
);
